import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { quotationItemRevisionsBackend } from './quotation-item-revisions.backend';
import { quotationItemRevisionsReducer } from './quotation-item-revisions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'quotationItemRevisions',
      quotationItemRevisionsReducer,
    ),
    BackendModule.forFeature(
      'quotationItemRevisions',
      quotationItemRevisionsBackend,
    ),
  ],
})
export class DatastoreQuotationItemRevisionsModule {}
